export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11642.d404bf29.jpg";